<script lang="ts">
  export let checked = false;
  export let labels = [];
  export let size = 'l';
</script>

<div class="toggle" class:checked>
  {#if labels[0]}
    <span class="label">{labels[0]}</span>
  {/if}
  <span class="slider size-{size}" on:click />
  {#if labels[1]}
    <span class="label">{labels[1]}</span>
  {/if}
</div>

<style lang="scss">
  .toggle {
    position: relative;
    display: inline-flex;
    align-items: center;
    margin-left: auto;
    top: 1px;
  }

  .slider {
    position: relative;
    width: 41px;
    height: 24px;
    background-color: #dddddd;
    border-radius: 1000px;
    transition: 0.4s;
    cursor: pointer;
    margin: 0 12px;

    &.size-l {
      width: 46px;
      height: 28px;
      margin: 0;
      margin-left: auto;
      &::before {
        height: 22px;
        width: 22px;
        left: 3px;
        bottom: 3px;
      }
    }

    &.size-m {
      margin: 0;
      margin-left: auto;
      transform: scale(0.85);
    }
  }

  .label {
    font-size: 12px;
  }

  .slider:before {
    position: absolute;
    content: '';
    height: 20px;
    width: 20px;
    left: 2px;
    bottom: 2px;
    border-radius: 100%;
    background-color: white;
    transition: 0.4s;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08), 0 1px 1px rgba(0, 0, 0, 0.1);
  }

  .toggle.checked .slider {
    background-color: var(--color-green--400);
  }

  .toggle.checked .slider:before {
    transform: translateX(17px);
  }

  .toggle.checked .slider.size-l:before {
    transform: translateX(18px);
  }
</style>
